'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
export default {
  empty: '',
  validating: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "validatedFormControl.validationMessageDefaults.email.validating"
  }),
  success: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "validatedFormControl.validationMessageDefaults.email.success"
  }),
  error: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "validatedFormControl.validationMessageDefaults.email.error"
  })
};